/* global youbora */
if (typeof youbora !== 'undefined') {
  youbora.registerAdapter('Ima', require('./adapter'))
  module.exports = youbora
}
